'use client';

import { useTranslations } from 'next-intl';
import { HeroBanner } from '@/components/frontend/common/hero-banner';
import { CountryIntroductionSection } from './common/country-introduction-section';
import { CountryStepsSection } from './common/country-steps-section';
import { CountryFeaturesSection } from './common/country-features-section';
import { CountryNetworkMarketingSection } from './common/country-network-marketing-section';
import { CountryTeamSupportSection } from './common/country-team-support-section';

export function ItalyPageContent() {
    const t = useTranslations('italyPage');
    const translationNamespace = 'italyPage';

    return (
        <div className="min-h-screen bg-white dark:bg-black">
            <HeroBanner
                page={t('hero.page')}
                title={t('hero.title')}
                description={t('hero.subtitle')}
                pill={t('hero.pill')}
                className="border-b border-gray-200 dark:border-gray-900"
            />

            <CountryIntroductionSection
                translationNamespace={translationNamespace}
                countryImage="/images/countries/best-mlm-software.webp"
            />
            <CountryStepsSection translationNamespace={translationNamespace} />
            <CountryFeaturesSection translationNamespace={translationNamespace} />
            <CountryNetworkMarketingSection translationNamespace={translationNamespace} />
            <CountryTeamSupportSection translationNamespace={translationNamespace} />
        </div>
    );
}

